module.exports = __webpack_public_path__ + "static/media/Sabrina J.337b2a82.jpg";